import { getChainsAddNetWork } from "_src/utils/chain/chainConfUtil";

import store from "_src/store";

const isNeedWalletAddChain = (switchError) => {
  if (switchError) {
    // This error code indicates that the chain has not been added to MetaMask.
    if (switchError?.code === 4902 || switchError?.code === -32603) return true;
    // This error code indicates that the chain has not been added to WallectConnect.
    // TODO 无法拿到错误的状态 后期需要优化

    if (
      switchError?.message &&
      switchError.message.includes("wallet_addEthereumChain")
    )
      return true;
  }

  return false;
};

export const publicSelectChain = async (chainId) => {
  // web3 都要从 store 统一入口 中取
  const { wallet } = store.getState();
  const { web3 = "" } = wallet;

  if (!web3) return;

  try {
    await web3.currentProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId }],
    });

    // TODO 无法拿到成功的状态
    return new Promise((resolve) => {
      resolve(chainId);
    });
  } catch (switchError) {
    if (isNeedWalletAddChain(switchError)) {
      try {
        const addNetWorkItem = getChainsAddNetWork(chainId);

        await web3.currentProvider.request({
          method: "wallet_addEthereumChain",
          params: [addNetWorkItem],
        });

        // TODO 无法拿到成功的状态
        return new Promise((resolve) => {
          resolve(chainId);
        });
      } catch (addError) {
        // throw addError;
        console.log(addError);
        return new Promise((resolve, reject) => {
          reject(false);
        });
      }
    }

    // User rejected the request.
    if (switchError?.code === 4001) {
      return new Promise((resolve, reject) => {
        reject(false);
      });
    }
  }
};
